<template>
	<div class="game-detail">

		<mq-layout :mq="['mob', 'ptab']" class="game-detail__banner" v-bind:style="{ backgroundImage: `url('${overviewImage}')` }">

			<span class="fonticon fonticon--close--filled game-detail__banner-close" @click="$emit('close-game-detail', game)"></span>
			<btn class="btn--style--fill--font" @click="watchVideo()" v-if="game.videoId">
				<span class="fonticon fonticon--play"></span>
				<span>Watch Video</span>
			</btn>

		</mq-layout>

		<nav class="game-detail__nav">
			<div class="grid grid--center grid--auto grid--g32--phab">
				<div class="grid__item">
					<a class="game-detail__nav-item link--action" v-bind:class="{
						'game-detail__nav-item--active link--colored': activeNav == 'overview'
					}" @click="activeNav = 'overview'; trackEvent([
						'game-tab-overview-clicked',
						game.gameName,
						$root.$data.user ? $root.$data.user.trackName : null,
						0,
						false
					])">Overview</a>
				</div>
				<div class="grid__item">
					<a class="game-detail__nav-item link--action" v-bind:class="{
						'game-detail__nav-item--active link--colored': activeNav == 'info'
					}" @click="activeNav = 'info'; trackEvent([
						'game-tab-info-clicked',
						game.gameName,
						$root.$data.user ? $root.$data.user.trackName : null,
						0,
						false
					])">Game Info</a>
				</div>
				<div class="grid__item">
					<a class="game-detail__nav-item link--action" v-bind:class="{
						'game-detail__nav-item--active link--colored': activeNav == 'screens'
					}" @click="activeNav = 'screens'; trackEvent([
						'game-tab-screens-clicked',
						game.gameName,
						$root.$data.user ? $root.$data.user.trackName : null,
						0,
						false
					])">Game Screens</a>
				</div>
			</div>
			<mq-layout mq="ltab+" class="fonticon fonticon--close--filled game-detail__nav-close" @click.native="$emit('close-game-detail', game)"></mq-layout>
		</nav>

		<div class="game-detail__overview" v-if="activeNav == 'overview'">
			<div class="grid grid--b0 grid--v-spread-items">
				<div class="grid__item one-half--not-phab">

					<div class="game-detail__overview-content-wrapper page-container">
						<GameIntro class="game-detail__intro" :game="game"></GameIntro>
					</div>

				</div>
				<mq-layout :mq="['ltab', 'desk']" class="grid__item one-half game-detail__overview-image-wrapper" v-bind:style="{ backgroundImage: `url('${overviewImage}')` }">

					<btn class="btn--style--fill--font" @click="watchVideo()" v-if="game.videoId">
						<span class="fonticon fonticon--play"></span>
						<span>Watch Video</span>
					</btn>

				</mq-layout>
			</div>
		</div>

		<div v-if="activeNav == 'info'" class="page-container">
			<game-info class="game-detail__info" :game="game"></game-info>
		</div>

		<div class="game-detail__screens" ref="gameScreensTab" v-if="activeNav == 'screens'">
			<div class="page-container--phab game-detail__screens-centraliser">

				<mq-layout :mq="['mob', 'ptab']">
					<div class="game-detail__screen"  v-for="image in gameScreens">
						<img class="game-detail__screen-image"  :src="image.src" @click="gameScreenLoaded" @load="gameScreenLoaded" />
						<div class="game-detail__screen-description">{{image.description}}</div>
					</div>
				</mq-layout>

				<mq-layout :mq="['ltab', 'desk']">
					<carousel :images="gameScreens" class="game-detail__screens-carousel"></carousel>
				</mq-layout>

			</div>
		</div>

	</div>
</template>

<script>
import { map } from 'lodash';

import Btn from '../atoms/Btn'
import GameIntro from '../molecules/GameIntro'
import GameInfo from '../molecules/GameInfo'
import Carousel from '../organisms/Carousel'

export default {
	name: 'GameDetail',
	components: {
		Btn,
		GameIntro,
		GameInfo,
		Carousel,
	},
	data () {
		return {
			'activeNav': 'overview'
		}
	},
	props: {
		game: Object
	},
	computed: {
		overviewImage: function()
		{
			var self = this;
			var overviewImage = '';

			if(self.game.assets.gameScreens && self.game.assets.gameScreens.length > 0)
			{
				overviewImage = self.game.assets.gameScreens[0].link;
			}

			return overviewImage;
		},
		gameScreens: function()
		{
			var self = this;
			var gameScreens = [];

			if(self.game.assets.gameScreens && self.game.assets.gameScreens.length > 0)
			{
				gameScreens = map(self.game.assets.gameScreens, (item) => ({
					src: item.link,
					description: item.metadata
					// description: item.metadata && item.metadata.hasOwnProperty('alt') ? item.metadata.alt : ''
				}));
			}

			return gameScreens;
		},
	},
	created: function()
	{
	},
	mounted: function()
	{
		var self = this;
		document.addEventListener('keyup', self.close);
	},
	beforeDestroy: function()
	{
		var self = this;
		document.removeEventListener('keyup', self.close);
	},
	methods: {
		gameScreenLoaded: function(evt)
		{
			var self = this;

			// Fix for certain iOS devices to force a recalculate
			var height = self.$refs.gameScreensTab.offsetHeight;
			self.$refs.gameScreensTab.style.height = (height + 1) + "px";		// Add one to always force a change

			self.$nextTick(() => {
				self.$refs.gameScreensTab.style.removeProperty("height");
			});
		},
		watchVideo: function()
		{
			var self = this;

			self.$root.$data.gameVideoId = self.game.videoId;

			self.trackEvent([
				'video-played',
				self.game.videoId,
				self.$root.$data.user ? self.$root.$data.user.trackName : null,
				0,
				false
			]);

			self.trackEvent([
				'game-video-played',
				self.game.gameName,
				self.$root.$data.user ? self.$root.$data.user.trackName : null,
				0,
				false
			]);
		},
		close: function(evt)
		{
			var self = this;
			if(evt.type !== "keyup" || (evt.type === "keyup" && evt.keyCode === 27))
			{
				self.$emit('close-game-detail', self.game);
			}
		}
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".game-detail";
	#{$c}
	{
		&__banner
		{
			position: relative;
			@include extend(bg-fill);
			display: flex;
			align-content: center;
			align-items: center;
			justify-content: center;
			max-height: 300px;

			&:before
			{
				content: "";
				display: block;
				padding-top: 100% * (210/375);
			}

			&-close
			{
				position: absolute;
				cursor: pointer;
				font-size: rem(40);
				top: rem(16);
				right: rem(16);
				color: palette(white);
			}
		}

		&__nav
		{
			position: relative;
			padding: { top: rem(30); bottom: rem(30); }
			background-color: palette(white);

			&-item
			{
				@include extend(ui-underline);
				@include extend(ui-underline--blue);
				@include media(phab) { font-size: 12px; }

				&--active
				{
					@include extend(ui-underline--active);
				}
			}

			&-close
			{
				position: absolute;
				cursor: pointer;
				font-size: rem(40);
				top: 50%;
				right: rem(48);
				transform: translateY(-50%);
			}
		}

		&__overview-content-wrapper
		{
			padding-top: rem(40);
			padding-bottom: rem(70);

			@include media(not-phab)
			{
				@include extend(block-right);
				max-width: $page-padding + round($page-width / 2);
			}
		}

		&__overview-meta
		{
			margin-bottom: rem(24);
		}

		&__overview-separator
		{
			display: block;
			line-height: 0;
			width: 1px;
			height: rem(24);
			background-color: palette(divider);
		}

		&__overview-date
		{
			@include extend(h5);
			margin-bottom: rem(8);
		}

		&__overview-channel
		{
			font-size: rem(32);
		}

		&__overview-open
		{
			font-size: rem(40);
		}

		&__description
		{
			color: palette('grey');

			@include media(not-phab)
			{
				max-width: 536px;
			}
		}

		&__overview-actions
		{
			margin-top: rem(56);
		}

		&__overview-image-wrapper
		{
			position: relative;
			background-color: palette(lightest-grey);
			@include extend(bg-fill);
			display: flex;
			align-content: center;
			align-items: center;
			justify-content: center;

			&:before
			{
				content: "";
				display: block;
				@include extend(absolute-fill);
				left: -1px;			// Bug fix
				width: 15%;
				background-image: linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0.75) 50%, rgba(255,255,255,0));
			}
		}

		&__overview-play
		{
			min-width: 164px;

			@include media(not-phab)
			{
				min-width: 217px;
			}
		}

		&__info
		{
			padding-top: rem(40);
			padding-bottom: rem(70);
			max-width: 1000px;
			@include extend(block-center);
		}

		&__screens
		{
			padding-top: rem(25);
			padding-bottom: rem(50);

			.carousel__items
			{
				@include extend(page-container--not-phab);

				@include breakpoint(min-width (strip-units($page-width + (2 * $page-padding)) * 1em/16))
				{
					padding-left: calc((100vw - #{$page-width}) / 2);
					padding-right: calc((100vw - #{$page-width}) / 2);
					max-width: none;
				}
			}

			.carousel__item
			{
				max-width: 648px + 48px;
				padding-right: rem(48);

				&:last-child
				{
					max-width: 648px + $page-padding;
					padding-right: $page-padding;

					@include breakpoint(min-width (strip-units($page-width + (2 * $page-padding)) * 1em/16))
					{
						max-width: calc(648px + ((100vw - #{$page-width}) / 2));
						padding-right: calc((100vw - #{$page-width}) / 2);
					}
				}
			}
		}

		&__screen
		{
			margin-bottom: 2em;

	    &-image
	    {
  	  	@include extend(block-img);
  	  }

    	&-description
    	{
    		margin-top: 1em;
    	}
    }
	}

</style>



// WEBPACK FOOTER //
// src/components/organisms/GameDetail.vue